export interface IThinProfile {
  id: string;
  type: 'thin_profiles';
  prefix_name: string;
  first_name: string;
  last_name: string;
  email: string;
  institution: string;
  organizational_role: string;
  short_bio: string;
  slug: string;
  original_square_avatar_url: string;
  medium_square_avatar_url: string;
  website: string;
  linkedin: string;
  orchid: string;
  google_scholar: string;
  twitter: string;
  github: string;
  // Subscription properties (snake_case from API)
  newsletter_subscription?: boolean;
  pending_subscription?: boolean;
  event_updates_subscription?: boolean;
  library_updates_subscription?: boolean;
  email_public?: boolean;
  visible_in_event_chats_list?: boolean;
  email_notification_on_lecture_comment?: boolean;
  email_notification_on_event_announcement?: boolean;
  email_notification_on_chat_messages?: boolean;
  email_notification_on_lecture_reply?: boolean;
  weekly_analytics_email_notification?: boolean;
  engineering_technology_subscription?: boolean;
  health_sciences_subscription?: boolean;
  life_sciences_subscription?: boolean;
  social_sciences_subscription?: boolean;
  physics_subscription?: boolean;
  computer_science_subscription?: boolean;
  event_updates?: boolean;
  library_updates?: boolean;
  // Computed (added after enrichment)
  full_name?: string;
  link_slug?: string;
  square_avatar?: string;
  avatar?: string;
  title?: string;
}

export function enrichThinProfile(profile: IThinProfile): IThinProfile {
  const full_name = [profile.prefix_name, profile.first_name, profile.last_name].filter(Boolean).join(' ');
  const title = [profile.organizational_role, profile.institution].filter(Boolean).join(' @ ');
  const link_slug = `${profile.id}-${profile.slug}`;
  const square_avatar = profile.medium_square_avatar_url || '/images/placeholderSquareSpeaker.png';
  const avatar = profile.medium_square_avatar_url || '/images/placeholderSpeaker.png';

  return {
    ...profile,
    full_name,
    title,
    link_slug,
    square_avatar,
    avatar,
  };
}
